import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth/auth.service';
import { RatingService } from '../services/rating/rating.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Router } from '@angular/router';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(
    private authenticationService: AuthService,
    private ratingService: RatingService,
    private jwtHelper: JwtHelperService,
    public router: Router
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.headers.has('skip-interceptor')) {
      const clonedRequest = request.clone({
        headers: request.headers.delete('skip-interceptor')
      });
      return next.handle(clonedRequest);
    }

    // add authorization header with jwt token if available
    let currentUser = this.authenticationService.userData;
    const token = localStorage.getItem('accessToken');

    const accessToken = currentUser?.token || token;

    if (accessToken) {
      if (!request.url.includes('https://maps.googleapis.com/')) {
        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${accessToken}`,
            'Access-Control-Allow-Origin': '*'
          }
        });
      }

      if (this.jwtHelper.isTokenExpired(accessToken)) {
        this.ratingService.ratingSaved.next(true);
        this.authenticationService.Logout();
        this.router.navigate(['/']);
      }
    }

    return next.handle(request);
  }
}
